import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { changeImpedancePage, createNewLayout, deleteLayout, deleteLayoutConnector, deleteShip, traceOverview, updateImpedanceStatus, createDie, saveOnDieModel, saveMultiPCBTarget, saveDieCurrent, savePMICVoltage, switchPackage, switchPcb, saveInterposer, saveInterposerNode, saveHasInterposer, updateCurrentStatus, saveRleakAndRrdl, saveTransientTimeSetting, createModel, saveSocket, createPackageFile, updatePackageFile, saveVRM, refreshInterposer } from '../store/Impedance/action';
import { CloseOutlined, ImportOutlined, PlayCircleOutlined, PlusCircleOutlined, ArrowDownOutlined, RetweetOutlined, CloseCircleFilled, RedoOutlined } from '@ant-design/icons';
import { Tooltip, Spin, Button, Tag, Input, message, Select, TreeSelect, Checkbox, Popover } from 'antd';
import { sortOverviewComps, reverseOverviewComps, getDiePortsByCPM } from '../../../services/Cascade/Impedance';
import PCBPanel from './pcbPanel';
import ConnectorPanel from './pcbPanel/connectorPanel';
import { BGA, CONNECTOR, DIE, PMIC, VRM, IC } from '../../../constants/componentType';
import { PACKAGE } from '../../../constants/treeConstants';
import { OverviewPlot } from '../../../services/Cascade/Impedance/overviewCanvas';
import { IMPEDANCE_DIE, IMPEDANCE_INTERPOSER, IMPEDANCE_INTERPOSER_LAYOUT, IMPEDANCE_LAYOUT_LIST, IMPEDANCE_PACKAGE, IMPEDANCE_PACKAGE_FILE, IMPEDANCE_PACKAGE_LIST, IMPEDANCE_PCB, IMPEDANCE_SOCKET, PACKAGE_FILE, SOCKET, TARGET_DIE_INDEX, TARGET_PACKAGE_INDEX } from '../../../services/Cascade/constants';
import { CASCADE } from '../../../constants/pageType';
import CascadeOnDieModelPanel from '../../../components/OnDieFilePanel/cascadeOnDieModelPanel';
import { getCascadeCSMCPMSpiceModelList, getPkgSpiceModelList, getTreeSelectList } from '../../../services/Cascade/library';
import designConstructor from '../../../services/helper/designConstructor';
import TargetPanel from './targetPanel';
import DieCurrentPanel from './dieCurrentPanel';
import { PCB_PACKAGE_DIE } from '../../../constants/resolution';
import { numberCheck } from '@/services/helper/dataProcess';
import { numExponentialFormat } from '@/services/helper/numberHelper';
import SwitchPcbPanel from './switchPcbPanel';
import CPMCSMContent from '../../../components/CPMCSMSetup/cpmCsmContent';
import CpmCsmSelectPanel from '../../../components/CPMCSMSetup/CpmCsmSelectPanel';
import InterPoserPanel from './interposerPanel'
import { getAutoConnectorNets, getLayoutConnectionShip, getSocketPorts } from '../../../services/Cascade/helper/setupData';
import RleakRdlPanel from './rleakRdlPanel';
import TransientTimePanel from './transientTimePanel';
import AddModelPanel from './addModelPanel';
import ModelPanel from './modelPanel';
import { getPortByTouchstone } from '../../../services/helper/getPortByTouchstone';
import { TOUCHSTONE, SPICE } from '../../../services/Cascade/constants';
import DelConfirm from '@/components/DelConfirm';
import _ from 'lodash'

const PER_PORT = 'perPort'
class OverviewPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      width: 300,
      height: 150,
      layoutList: [],
      positionList: [],
      addPCB: false,
      addConnector: false,
      onDie: false,
      openTarget: false,
      openCurrent: false,
      openSwitchPkg: false,
      currentPkgId: '',
      portInfo: new Map(),
      portSelect: new Map(),
      portCount: 0,
      openInterposer: false,
      nodes: [],
      maxStopTime: 0,
      addModelIndex: false,
      modelVisible: false,
      portList: [],
      modelType: '',
      leftModelTitle: '',
      rightModelTitle: '',
      message: false
    }
  }

  resizeCanvas = () => {
    const content = document.getElementById('cascade-imp-overview-content');
    const contentOffset = content.getBoundingClientRect();
    const { width, height } = contentOffset;
    this.setState({
      width,
      height
    }, () => {
      this.getLinePosition()
    })
  }

  getLinePosition = () => {
    const { layoutList } = this.state;
    const { data, impedanceOverviewDisplay, hasInterposer, customModelType } = this.props;
    const overviewReverse = impedanceOverviewDisplay === PCB_PACKAGE_DIE
    let indexs = [...new Set(data.map(item => item.index))].sort();
    if (overviewReverse) {
      indexs = indexs.reverse()
    }
    let totalLeft = 0, positionList = [];
    for (let index of indexs) {
      const layouts = data.filter(item => item.index === index);
      let totalHeight = 0;
      for (let layout of layouts) {
        const { designId, designName: _designName } = layout;
        const designName = designConstructor.getDesignName(designId) || _designName;
        const id = `PCB-${designName.replace(/[^\w\d_]/g, '')}`;
        const currentLayout = layoutList.find(item => item.designId === designId);
        const { left, right } = currentLayout;
        let _totalHeight = totalHeight, _totalLeft = totalLeft;
        [...left, ...right].forEach(item => {
          const { name, index, side, data } = item;
          const _ele = name === 'Die' ?
            (customModelType === 'unified' ? document.getElementById(`layout-unified-die-${index}`) : document.getElementById(`layout-current-icon-${index}`))
            : designId === IMPEDANCE_PACKAGE_FILE ? document.getElementById(`${id}-${IMPEDANCE_PACKAGE_FILE}`)
              : document.getElementById(`${id}-${name}-${index}`);
          if (_ele) {
            const top = _ele.offsetTop;
            const left = _ele.offsetLeft;
            const height = _ele.offsetHeight;
            positionList.push({
              // top: prevHeight + layout Margin + title Margin + title Height + add Connection Height + top + 0.5 height
              name, index, data, side, designId, top: _totalHeight + 10 + 28 + 40 + top + 0.5 * height, left: _totalLeft + left + 10
            })
          }
        })
        const ele = document.getElementById(id);
        if (ele) {
          totalHeight = totalHeight + ele.offsetHeight;
        }
      }
      if (hasInterposer) {
        const targetIndex = overviewReverse ? TARGET_PACKAGE_INDEX : TARGET_DIE_INDEX;
        totalLeft += (index === targetIndex) ? 600 : 300;
      } else {
        totalLeft += 300;
      }
    }
    this.setState({
      positionList
    }, () => {
      this.draw()
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.resizeCanvas);
    this.getComponents();
    this.getPortTreeData()
    this.initDefaultCurrentStopTime()
  }

  componentDidUpdate(prevProps) {
    const { data, verificationId, page, status, impedanceOverviewDisplay, hasInterposer, customModelType, ICs = [] } = this.props;
    const baseChanged = data.length !== prevProps.data.length || verificationId !== prevProps.verificationId || page !== prevProps.page || impedanceOverviewDisplay !== prevProps.impedanceOverviewDisplay || hasInterposer !== prevProps.hasInterposer;

    if (baseChanged || status) {
      this.getComponents();
      this.initDefaultCurrentStopTime();
      this.props.updateImpedanceStatus(false);
    }

    const icsChanged = customModelType !== prevProps.customModelType || !_.isEqual(
      ICs.map(({ powerNet = '', name = '', portIndex = '' }) => ({ powerNet, name, portIndex })),
      (prevProps.ICs || []).map(({ powerNet = '', name = '', portIndex = '' }) => ({ powerNet, name, portIndex }))
    );

    if (baseChanged || icsChanged) {
      this.getPortTreeData();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCanvas)
  }

  getComponents = () => {
    const { data, impedanceOverviewDisplay } = this.props
    if (!data || !data.length) {
      this.setState({
        layoutList: []
      }, () => {
        this.resizeCanvas();
      })
      return;
    }
    const layoutList = impedanceOverviewDisplay === PCB_PACKAGE_DIE ? reverseOverviewComps(data) : sortOverviewComps(data);
    const { newLayoutList, dieShowData } = this.initDieLayoutData(layoutList)
    this.setState({
      layoutList: newLayoutList,
      dieShowData
    }, () => {
      this.resizeCanvas();
    })
  }

  initDefaultCurrentStopTime = () => {
    const { data } = this.props
    let maxStopTime = 0
    data.forEach(item => {
      item.ICs.forEach(ic => {
        if (ic.dieCurrent) {
          if (Number(ic.dieCurrent.stopTime) > maxStopTime) {
            maxStopTime = Number(ic.dieCurrent.stopTime)
          }
        }
      })
    })
    this.setState({
      maxStopTime
    })
  }

  initDieLayoutData = (layoutList) => {
    const { impedanceOverviewDisplay } = this.props
    const { portSelect } = this.state
    let newLayoutList = JSON.parse(JSON.stringify(layoutList))
    let dieShowData = []
    const findDieIndex = newLayoutList.findIndex(item => item.designId === 'Die')
    if (findDieIndex > -1) {
      const layout = newLayoutList[findDieIndex]
      let data = []
      let currentComp = null
      dieShowData = impedanceOverviewDisplay === PCB_PACKAGE_DIE ? JSON.parse(JSON.stringify(layout.left)) : JSON.parse(JSON.stringify(layout.right))
      dieShowData.forEach(item => {
        const comp = item.data.to[0].components[0]
        const compPort = portSelect.get(comp)
        const currentPort = compPort ? compPort.split('-') : []
        const powerNet = currentPort.length ? currentPort[0] : null
        const port = currentPort.length ? currentPort[1] : null
        if (currentComp !== comp) {
          if (powerNet && port) {
            if (item.data.powerNet === powerNet && item.data.portIndex === port) {
              data.push({ ...item, index: data.length })
              currentComp = comp
            }
          } else {
            data.push({ ...item, index: data.length })
            currentComp = comp
          }
        }
      })
      const interposer = data.length ? data[0].data.interposer : null
      this.initInterposerNodes(interposer)
      if (impedanceOverviewDisplay === PCB_PACKAGE_DIE) {
        layout.left = [...data]
      } else {
        layout.right = [...data]
      }
      layout.height = data.length * 100 + 30 + 40 + 40;
      newLayoutList[findDieIndex] = layout
    }
    return { newLayoutList, dieShowData }
  }

  changeImpedancePage = (e, designId, type) => {
    e && e.stopPropagation()
    if (IMPEDANCE_LAYOUT_LIST.includes(type)) {
      this.props.changeImpedancePage(designId)
    }
  }

  changeAddPCBVisible = (boolean) => {
    this.setState({
      addPCB: boolean
    })
  }

  changeAddConnVisible = (addConnector) => {
    this.setState({
      addConnector
    })
  }

  deleteLayout = (e, designId, index) => {
    e && e.stopPropagation();
    if (designId === IMPEDANCE_DIE) {
      this.setState({
        onDie: false,
        cpmCsmVisible: false,
        openCurrent: false,
        openRleakRdl: false
      })
    }
    this.props.deleteLayout(designId, index);
  }

  deleteInterposer = (e) => {
    e && e.stopPropagation();
    this.props.saveHasInterposer(false)
  }

  switchPkg = (e, designId) => {
    e && e.stopPropagation();
    this.setState({
      currentPkgId: designId === IMPEDANCE_PACKAGE_FILE ? "" : designId,
      openSwitchPkg: true
    })
  }

  changeSwitchPcb = (e, designId) => {
    e && e.stopPropagation()
    this.setState({
      currentPcbId: designId,
      openSwitchPcb: true
    })
  }

  switchPcb = (pcbId) => {
    const { currentPcbId } = this.state
    if (pcbId !== currentPcbId) {
      this.props.switchPcb(pcbId, currentPcbId)
    }
  }

  deleteConnector = (e, designId, connector) => {
    e && e.stopPropagation();
    this.props.deleteConnector(designId, connector)
  }

  draw = () => {
    const { impedanceOverviewDisplay, customModelType } = this.props
    const reverse = impedanceOverviewDisplay === PCB_PACKAGE_DIE
    if (!this.brush) {
      const { width, height, positionList } = this.state;
      this.brush = new OverviewPlot({ id: 'impedance-overview', width, height, data: positionList, customModelType });
    }
    const { width, height, positionList } = this.state;
    this.brush.reset({ width, height, customModelType })
    this.brush.set('data', positionList);
    this.brush.draw(reverse);
  }

  closeOnDiePanel = (name, info, powerNet, targetDie, apply, customType, dieCurrentList) => {
    const { modelPowerNet, modelIndex } = this.state
    this.props.saveOnDieModel(info, targetDie, modelPowerNet, modelIndex, apply, customType, dieCurrentList)
    this.setState({
      onDie: false
    })
  }

  changeOnDie = async (targetDie, model, powerNet, portIndex) => {
    const { data } = this.props;
    const pkg = data.find(item => IMPEDANCE_PACKAGE_LIST.includes(item.type));
    const die = data.find(item => item.type === IMPEDANCE_DIE);
    if (!pkg || !die) {
      return;
    }
    const targetPkg = pkg.powerDomains.find(domain => {
      return domain.content.Components.find(comp => comp.name === targetDie) && domain.content.PowerNets.includes(powerNet)
    })
    const powerNets = targetPkg.content.PowerNets
    const gndNets = targetPkg.content.ReferenceNets
    const ports = targetPkg.content.diePorts && targetPkg.content.diePorts.length ? targetPkg.content.diePorts : [{ port: '1' }]
    const customType = die.customType
    let _model = { ...model }
    if (customType === 'unified' || customType === "CPM") {
      const mergedModel = {
        ...die.ICs[0].model,
        pairs: [],
      };
      die.ICs.forEach((item, index) => {
        if (item.to[0].components[0] === targetDie && item.model.pairs && item.model.pairs.length) {
          const pair = {
            pin: `${item.powerNet}-${item.model.pairs[0].pin}`,
            node: item.model.pairs[0].node
          }
          mergedModel.pairs.push(pair);
          if (index === die.ICs.length - 1) {
            mergedModel.pairs.push(item.model.pairs[1]);
          }
        }
      });
      _model = { ...mergedModel }
    }

    const dieCurrentList = die.ICs.map(item => item.dieCurrent || {})
    const pdnInfo = {
      gndNet: [...new Set(gndNets)],
      powerNets: [...new Set(powerNets)].map(powerNet => ({ powerNet, onDie: _model })),
      ports: ports,
      customType,
      dieCurrentList
    }
    this.setState({
      modelPowerNet: powerNet,
      modelIndex: portIndex,
      onDie: {
        pdnInfo,
        powerNet: [...new Set(powerNets)],
        targetDie,
        targetPkg,
        portIndex,
        pkgDomains: pkg.powerDomains
      }
    })
  }

  contentRender = () => {
    const { data, impedanceOverviewDisplay } = this.props;
    let indexs = [...new Set(data.map(item => item.index))].sort();
    if (impedanceOverviewDisplay === PCB_PACKAGE_DIE) {
      indexs = indexs.reverse()
    }
    return indexs.map((index, layoutIndex) => {
      const layouts = data.filter(item => item.index === index);
      let targetLayout = null
      if (impedanceOverviewDisplay === PCB_PACKAGE_DIE) {
        targetLayout = layoutIndex - 1 > -1 ? data.find(item => item.index === indexs[layoutIndex - 1]) : null;
      } else {
        targetLayout = layoutIndex + 1 < indexs.length ? data.find(item => item.index === indexs[layoutIndex + 1]) : null;
      }
      const targetType = targetLayout ? targetLayout.type : null
      const type = layouts && layouts.length ? layouts[0].type : null
      const hasSocket = [...IMPEDANCE_LAYOUT_LIST, ...IMPEDANCE_PACKAGE_LIST].includes(type) && targetType && ![IMPEDANCE_SOCKET, IMPEDANCE_DIE].includes(targetType)
      return <Fragment key={index}>
        {this.layoutsRender(layouts, index, hasSocket)}
      </Fragment>
    });
  }

  changeTargetPanel = (e, open) => {
    e && e.stopPropagation();
    this.setState({
      openTarget: open
    })
  }

  changeTransientPanel = (e, open) => {
    e && e.stopPropagation();
    this.setState({
      openTransientTime: open
    })
  }

  closeTransientTimePanel = (startTime, stopTime, stepTime) => {
    this.props.saveTransientTimeSetting(startTime, stopTime, stepTime)
    this.setState({
      openTransientTime: false
    })
  }

  openCurrentPanel = (e, dieCurrent, designId, name, powerNet, portIndex) => {
    e && e.stopPropagation()
    this.setState({
      dieCurrent,
      currentDesignId: designId,
      currentComp: name,
      currentPowerNet: powerNet,
      currentIndex: portIndex,
      openCurrent: true,
    })
  }

  changeCurrentPanel = (e, open) => {
    e && e.stopPropagation();
    this.setState({
      openCurrent: open
    })
  }

  changePkgPanel = (e, open) => {
    e && e.stopPropagation();
    this.setState({
      openSwitchPkg: open
    })
  }

  changePcbPanel = (e, open) => {
    e && e.stopPropagation();
    this.setState({
      openSwitchPcb: open
    })
  }

  changeCpmCsmVisible = (visible) => {
    this.setState({
      cpmCsmVisible: visible
    })
  }

  openAddModelPanel = (index) => {
    // this.setState({
    //   addModelIndex: index
    // })
    this.props.createModel(IMPEDANCE_SOCKET, index)
    // this.changeAddModelVisible(true)
  }

  changeAddModelVisible = (visible) => {
    this.setState({
      addModel: visible
    })
  }

  createModel = (layoutType) => {
    const { addModelIndex } = this.state
    this.props.createModel(layoutType, addModelIndex)
  }

  openModelPanel = (layoutIndex) => {
    const { data } = this.props
    const findIndex = data.findIndex(item => item.index === layoutIndex)
    const socket = data[findIndex].socket ? data[findIndex].socket : {}
    let leftPorts = [], rightPorts = [], modelType = SOCKET, leftModelTitle, rightModelTitle
    if (data[findIndex].type === IMPEDANCE_PACKAGE_FILE) {
      modelType = PACKAGE_FILE
      const pairs = socket.pairs || [];
      this.setState({
        portList: pairs,
        targetSocketIndex: layoutIndex,
        targetSocket: socket,
        modelType
      })
      this.changeModelVisible(true)
    } else if (data[findIndex].type === IMPEDANCE_SOCKET) {
      const findLeftIndex = data.findIndex(item => item.index === layoutIndex - 1)
      const findRightIndex = data.findIndex(item => item.index === layoutIndex + 1)
      if (findLeftIndex > -1) {
        const leftLayout = data[findLeftIndex]
        leftPorts = getSocketPorts(leftLayout, 'left')
        leftModelTitle = leftLayout.type === IMPEDANCE_INTERPOSER_LAYOUT ? 'Interposer' : [IMPEDANCE_PACKAGE, IMPEDANCE_PACKAGE_FILE].includes(leftLayout.type) ? 'Package' : 'PCB'
      }
      if (findRightIndex > -1) {
        const rightLayout = data[findRightIndex]
        rightPorts = getSocketPorts(rightLayout, 'right')
        rightModelTitle = rightLayout.type === IMPEDANCE_INTERPOSER_LAYOUT ? 'Interposer' : [IMPEDANCE_PACKAGE, IMPEDANCE_PACKAGE_FILE].includes(rightLayout.type) ? 'Package' : 'PCB'
      }
      let portList = [];
      if (leftModelTitle === 'Package' || rightModelTitle === 'Package') {
        portList = [{
          leftPorts,
          rightPorts,
          leftPowerNet: leftPorts[0] ? leftPorts[0].powerNet : '',
          rightPowerNet: rightPorts[0] ? rightPorts[0].powerNet : '',
          index: 0
        }]
      } else {
        let connectionShip = [], index = 0;
        if (findLeftIndex > -1 && findRightIndex > -1 && (data[findLeftIndex].type === IMPEDANCE_INTERPOSER_LAYOUT || data[findRightIndex].type === IMPEDANCE_INTERPOSER_LAYOUT)) {
          const nets = [...new Set([...leftPorts.map(port => port.powerNet), ...rightPorts.map(port => port.powerNet)])];
          for (let net of nets) {
            portList.push({
              leftPorts: leftPorts.filter(item => item.powerNet === net),
              rightPorts: rightPorts.filter(item => item.powerNet === net),
              leftPowerNet: net,
              rightPowerNet: net,
              index: index
            })
            index = index + 1
          }
        } else if (findLeftIndex > -1 && findRightIndex > -1) {
          connectionShip = getLayoutConnectionShip(data[findLeftIndex], 'from')
          for (let ship of connectionShip) {
            const [leftPowerNet, rightPowerNet] = ship;
            const _leftPorts = leftPorts.filter(item => item.powerNet === leftPowerNet);
            const _rightPorts = rightPorts.filter(item => item.powerNet === rightPowerNet);
            if (_leftPorts.length || _rightPorts.length) {
              portList.push({
                leftPorts: _leftPorts,
                rightPorts: _rightPorts,
                leftPowerNet: leftPowerNet,
                rightPowerNet: rightPowerNet,
                index: index
              })
              index = index + 1
            }
          }
        } else {
          const maxLength = Math.max(leftPorts.length, rightPorts.length);
          portList = Array.from({ length: maxLength }, (_, i) => ({
            leftPorts: [leftPorts[i]] || [],
            rightPorts: [rightPorts[i]] || [],
            leftPowerNet: leftPorts[i].powerNet,
            rightPowerNet: rightPorts[i].powerNet,
            index: i
          }));
        }
      }
      this.setState({
        portList,
        targetSocketIndex: layoutIndex,
        targetSocket: socket,
        modelType,
        leftModelTitle: leftModelTitle,
        rightModelTitle: rightModelTitle
      })
      this.changeModelVisible(true)
    }
  }

  closeModelPanel = ({ files, pairs }) => {
    const { targetSocketIndex } = this.state
    const { data } = this.props;
    if (data[targetSocketIndex] && data[targetSocketIndex].type === IMPEDANCE_PACKAGE_FILE) {
      this.props.updatePackageFile({ files, pairs })
    } else {
      this.props.saveSocket({ files, pairs, targetSocketIndex })
    }
    this.changeModelVisible(false)
  }

  changeModelVisible = (visible) => {
    this.setState({
      modelVisible: visible
    })
  }

  clickPairs = (e, targetDie) => {
    e && e.stopPropagation();
    const { data } = this.props;
    const pkg = data.find(item => IMPEDANCE_PACKAGE_LIST.includes(item.type));
    const die = data.find(item => item.type === IMPEDANCE_DIE);
    if (!pkg || !die) {
      return;
    }
    const ic = die.ICs.find(ic => ic.to[0].components[0] === targetDie)
    const model = ic ? ic.model : {}
    const targetPkg = pkg.powerDomains.find(domain => {
      return domain.content.Components.find(comp => comp.name === targetDie)
    })
    const powerNets = targetPkg.content.PowerNets
    const gndNets = targetPkg.content.ReferenceNets
    const pdnInfo = {
      gndNet: [...new Set(gndNets)],
      powerNets: [...new Set(powerNets)].map(powerNet => ({ powerNet, onDie: model }))
    }
    this.setState({
      pdnInfo,
      powerNet: [...new Set(powerNets)],
      targetDie,
      targetPkg
    })
    const _data = { powerNet: [...new Set(powerNets)], key: "CPM" }
    this.changeCpmCsmVisible(_data)
  }

  getPairs = (pairs) => {
    let _pairs = [];
    const length = pairs.length;
    if (length > 3) {
      _pairs = [pairs[0].node, "...", pairs[length - 1].node]
    } else {
      _pairs = pairs.map(item => item.node)
    }
    return _pairs;
  }

  getPairsNode = (cpmPairs, powerNets) => {
    if (cpmPairs && cpmPairs.length) {
      const powerPairs = cpmPairs.filter(item => powerNets.includes(item.net));
      const gndPairs = cpmPairs.filter(item => !powerNets.includes(item.net));
      const _pairs = [{
        top: '2px',
        list: this.getPairs(powerPairs),
        color: "#fd4242"
      },
      {
        top: '56px',
        list: this.getPairs(gndPairs),
        color: "#000"
      }]
      return _pairs
    }
  }

  getCPMCSMContent = (modelType, info, onRef) => {
    const { packageChannelId, channelId, packageId, pcb, cpmList, isPostPkgLayout } = this.props
    const { onDie } = this.state
    let ports = [];
    (onDie.pkgDomains || []).forEach(item => {
      const diePorts = item.content.diePorts && item.content.diePorts.length ? item.content.diePorts : [{ port: '1' }]
      const powerNet = item.content.PowerNets && item.content.PowerNets.length ? item.content.PowerNets[0] : null
      const portList = diePorts.map(p => `${powerNet}-${p.portName || p.port}`)
      ports.push(...portList)
    })
    const pins = [...ports, ...(onDie.pdnInfo.gndNet || [])]
    return <CPMCSMContent
      info={info}
      onRef={onRef}
      modelType={modelType}
      packageId={packageId}
      packageChannelId={packageChannelId}
      pcb={pcb}
      channelId={channelId}
      product={CASCADE}
      targetPkg={onDie.targetPkg}
      customSpiceList={cpmList}
      getCSMCPMSpiceModelList={getCascadeCSMCPMSpiceModelList}
      isPostPkgLayout={isPostPkgLayout}
      pins={pins}
      getDiePortsByCPM={getDiePortsByCPM}
    />
  }

  toInput = (e, name, type) => {
    e && e.stopPropagation();
    this.setState({
      [`${name}_${type}_input_status`]: true
    }, () => {
      const ele = document.getElementById(`${name}-${type}-input`);
      ele && ele.focus();
    })
  }

  savePowerDomainVoltage = (value, id, designId) => {
    this.props.saveVRM({ id: id, voltage: value, designId }, 'voltage');
  }

  saveValue = (e, prevValue, id, type, designId) => {
    e && e.stopPropagation();
    let value = e.target.value;
    if (prevValue !== value) {
      let errorCheck = null;
      if (value) {
        errorCheck = numberCheck(value)
      }
      if (errorCheck) {
        message.error(`${type} - ${errorCheck}`);
      } else {
        if (value && (value > 100 || value < 0.001)) {
          value = numExponentialFormat(value);
        }
        if (type === 'voltage') {
          this.savePowerDomainVoltage(value, id, designId)
        }
      }
    }
    this.setState({
      [`${id}_${type}_input_status`]: false
    })
  }

  getPortTreeData = () => {
    const { data } = this.props
    const findPkgIndex = data.findIndex(item => item.index === TARGET_PACKAGE_INDEX)
    const portInfo = new Map()
    if (findPkgIndex > -1) {
      const pkgLayout = data[findPkgIndex]
      pkgLayout.powerDomains.forEach(domain => {
        let count = 0
        const { MAIN_POWER_NETS, diePorts, Components } = domain.content
        const dieComp = Components.find(item => item.usage === DIE)
        const die = dieComp && dieComp.name ? dieComp.name : null
        const net = MAIN_POWER_NETS[0]
        const port = diePorts.length ? diePorts.map(item => {
          return { title: `${item.portName ? item.portName : `Port ${item.port}`}`, value: `${net}-${item.port}`, key: `${net}-${item.port}` }
        }) : [{ title: 'Lumped port', value: `${net}-1`, key: `${net}-1` }]
        const treeObj = { title: net, children: port, selectable: false, key: net, value: net }
        count += port.length
        if (portInfo.get(die)) {
          const ports = JSON.parse(JSON.stringify(portInfo.get(die).treeData))
          const _count = JSON.parse(JSON.stringify(portInfo.get(die).count))
          count += _count
          ports.push(treeObj)
          portInfo.set(die, { treeData: ports, count: count })
        } else {
          portInfo.set(die, { treeData: [treeObj], count: count })
        }
      })
    }
    const portSelect = new Map()
    portInfo.keys().forEach(key => {
      const treeData = portInfo.get(key).treeData
      const select = treeData.length ? treeData[0].children[0].value : null
      portSelect.set(key, select)
    })
    this.setState({
      portInfo,
      portSelect
    }, () => {
      this.getComponents()
    })
  }

  onPortChange = (value, index, targetDie) => {
    const { impedanceOverviewDisplay } = this.props
    const { dieShowData, layoutList, portSelect } = this.state
    const overviewReverse = impedanceOverviewDisplay === PCB_PACKAGE_DIE
    let _layoutList = JSON.parse(JSON.stringify(layoutList))
    const findDieIndex = _layoutList.findIndex(item => item.designId === 'Die')
    if (findDieIndex > -1) {
      const layout = JSON.parse(JSON.stringify(_layoutList[findDieIndex]))
      const side = overviewReverse ? 'left' : 'right'
      const compIndex = layout[side].findIndex(item => item.index === index)
      if (compIndex > -1) {
        const data = value.split('-')
        if (data.length) {
          const comp = layout[side][compIndex].data.to[0].components[0]
          const powerNet = data[0]
          const port = data[1]
          const _data = dieShowData.find(item => {
            const { data } = item
            return data.powerNet === powerNet && data.to[0].components[0] === comp && data.portIndex === port
          })
          if (_data) {
            const interposer = _data.data && _data.data.interposer ? _data.data.interposer : null
            this.initInterposerNodes(interposer)
            _layoutList[findDieIndex][side][compIndex] = { ..._data, index };
          }
        }
        const _portSelect = new Map(portSelect)
        _portSelect.set(targetDie, value)
        this.setState({
          portSelect: _portSelect,
          layoutList: _layoutList
        }, () => {
          this.resizeCanvas()
        })
      }
    }
  }

  getPortsNum = (layout) => {
    const { type, socket = {}, powerDomains = [] } = layout;
    let portsNum = 0, bgaPortsNum = 0, diePortsNum = 0
    if (type === IMPEDANCE_PACKAGE_FILE) {
      bgaPortsNum = (socket.pairs || []).filter(item => item.type === 'left').length;
      diePortsNum = (socket.pairs || []).filter(item => item.type === 'right').length;
    } else if (type === IMPEDANCE_PACKAGE) {
      (powerDomains || []).forEach(domain => {
        const { bgaPorts = [], diePorts = [] } = domain.content || {}
        bgaPortsNum += bgaPorts.length || 1;
        diePortsNum += diePorts.length || 1;
      });
    } else if (type === IMPEDANCE_PCB) {
      (powerDomains || []).forEach(domain => {
        const { ports = [] } = domain.content || {}
        portsNum += ports.length || 1
      })
    }
    return { portsNum, bgaPortsNum, diePortsNum }
  }

  updateCurrent = (dieCurrent, apply) => {
    const { currentComp, currentPowerNet, currentIndex, currentDesignId } = this.state
    this.props.saveDieCurrent({ dieCurrent, currentDesignId, currentComp, currentPowerNet, currentIndex, apply })
  }

  changeCurrentStatus = (e, designId, name) => {
    e && e.stopPropagation()
    this.props.updateCurrentStatus(e.target.checked, designId, name)
  }

  openInterposerPanel = (interposer, targetDie, powerNet, portIndex) => {
    const { data } = this.props
    const pkg = data.find(item => IMPEDANCE_PACKAGE_LIST.includes(item.type));
    if (!pkg) {
      return;
    }

    const _targetDie = pkg.type === IMPEDANCE_PACKAGE_FILE ? 'DIE' : targetDie
    this.setState({
      interposer,
      interposerPowerNet: powerNet,
      interposerIndex: portIndex,
      interposerDie: _targetDie,
      openInterposer: true
    })
  }

  closeInterposerPanel = (info, apply) => {
    const { interposerDie, interposerPowerNet, interposerIndex } = this.state
    this.props.saveInterposer(info, interposerDie, interposerPowerNet, interposerIndex, apply)
    this.setState({
      openInterposer: false
    })
  }

  getAutoConnectionNet = async (designId, connector, hasPassiveBoard) => {
    const { data, pcbId, targetIC } = this.props;
    const connectionNets = await getAutoConnectorNets(designId, data, connector, pcbId, targetIC, hasPassiveBoard);
    return connectionNets
  }

  changeRleakRdl = (e, rleak, rdl, targetDie, powerNet, portIndex) => {
    e && e.stopPropagation()
    this.setState({
      openRleakRdl: true,
      rleak,
      rdl,
      rComp: targetDie,
      rPowerNet: powerNet,
      rPortIndex: portIndex
    })
  }

  closeRleakRdlPanel = (rleak, rdl, apply) => {
    const { rComp, rPowerNet, rPortIndex } = this.state
    this.props.saveRleakAndRrdl({ rleak, rdl, apply, rComp, rPowerNet, rPortIndex })
    this.setState({
      openRleakRdl: false
    })
  }

  refreshInterposer = (e, designId) => {
    e && e.stopPropagation()
    this.props.refreshInterposer([designId])
  }

  inputRender = (value, id, type, designId) => {
    const inputStatus = this.state[`${id}_${type}_input_status`] || false
    return inputStatus ?
      <Input
        className="component-input"
        defaultValue={value}
        onBlur={(e) => this.saveValue(e, value, id, type, designId)}
        onPressEnter={(e) => this.saveValue(e, value, id, type, designId)}
        id={`${id}-${type}-input`}
      />
      : <span
        className={`component-span ${type === 'voltage' ? 'cascade-power-tree-value-title' : ''}`}
        style={{ cursor: 'pointer' }}
        onClick={(e) => this.toInput(e, id, type)}
      >{`${value ? value : '____'}`}</span>
  }

  saveNode = (value, key, name, powerNet, portIndex) => {
    this.props.saveInterposerNode(value, key, name, powerNet, portIndex)
    this.setState({
      [`${name}_${key}_select_status`]: false
    })
  }

  toSelect = (e, name, type) => {
    e && e.stopPropagation();
    this.setState({
      [`${name}_${type}_select_status`]: true
    }, () => {
      const ele = document.getElementById(`${name}-${type}-select`);
      ele && ele.focus();
    })
  }

  getComponentPowerDomains = (layout, name) => {
    if (layout && layout.type === IMPEDANCE_INTERPOSER_LAYOUT) {
      return;
    }
    const powerDomains = layout.powerDomains || [];
    const currentPowerDomains = powerDomains.filter(item => (
      item.content.Components.find(comp => comp.name === name) ||
      (item.content.VRM && item.content.VRM.find(vrm => vrm.VRM_COMP.includes(name) || vrm.powerPin.find(pin => pin.comp === name)))
    )).map(item => item.content.MAIN_POWER_NETS)
    return <div className="cascade-text-editor-tooltip">
      <div className='cascade-display-detail-box'>
        <div className='font-bold'>Included in the following Power Domains:</div>
        {
          currentPowerDomains.map((nets, index) => {
            return <div key={index}>   {index + 1}: {nets.join(', ')}</div>
          })
        }
      </div>
    </div>
  }

  selectRender = (value, unusedNodes, name, type, powerNet, portIndex) => {
    const selectStatus = this.state[`${name}_${type}_select_status`] || false
    return selectStatus ?
      <Select
        value={value}
        className='aurora-select layout-node-select'
        id={`${name}-${type}-select`}
        onBlur={() => this.setState({ [`${name}_${type}_select_status`]: false })}
        onSelect={(value) => this.saveNode(value, type, name, powerNet, portIndex)}
        allowClear={{ clearIcon: <CloseCircleFilled onClick={(e) => { this.saveNode('', type, name, powerNet, portIndex) }} /> }}
        defaultOpen={true}
        popupMatchSelectWidth={false}
        options={[value, ...unusedNodes].filter(item => !!item).map(node => ({
          value: node,
          label: node,
          title: node
        }))}
      />
      : <span
        className={`component-span`}
        style={{ cursor: 'pointer' }}
        onClick={(e) => this.toSelect(e, name, type)}
        title={value || ""}
      >{value ? value : <span className='layout-node-empty'></span>}
      </span>
  }

  initInterposerNodes = (model) => {
    const { customSpiceList, customTouchstoneList } = this.props
    const touchstoneSpiceList = [...customSpiceList, ...customTouchstoneList].map(item => getTreeSelectList(item))
    if (model && model.libraryId && model.fileName) {
      const file = touchstoneSpiceList.find(item => item.id === model.libraryId)
      if (file) {
        if (file.modelType === SPICE) {
          try {
            getPkgSpiceModelList(model.libraryId, model.fileName, 'SPICE').then(res => {
              let subcktList = [];
              subcktList = res && res.models && Array.isArray(res.models) ? [...res.models] : []
              const subckt = subcktList.find(item => item.name === model.subckt)
              this.setState({
                nodes: subckt ? subckt.ports : [],
              })
            });
          } catch (error) {
            console.error(error)
          }
        } else if (file.modelType === TOUCHSTONE) {
          this.setState({
            nodes: getPortByTouchstone(model.fileName)
          })
        }
      } else {
        this.setState({
          nodes: []
        })
      }
    } else {
      this.setState({
        nodes: []
      })
    }
  }

  interposerRender = (index) => {
    const { impedanceOverviewDisplay, targetDie, interposerType } = this.props
    const { portSelect, layoutList, portInfo, nodes } = this.state
    const overviewReverse = impedanceOverviewDisplay === PCB_PACKAGE_DIE
    const die = targetDie[0]
    const _portInfo = portInfo.get(die)
    const portCount = _portInfo ? _portInfo.count : '0'
    const portInfoTreeData = _portInfo ? _portInfo.treeData : []
    const portInfoList = portInfoTreeData.reduce((acc, item) => {
      return acc.concat(item.children.map(child => child.value));
    }, []);
    const _portSelect = portSelect.get(die)
    const currentPort = portInfoList.findIndex(item => item === _portSelect) + 1
    const portSelectInfo = _portSelect ? _portSelect.split('-') : []
    const powerNet = portSelectInfo.length ? portSelectInfo[0] : null
    const portIndex = portSelectInfo.length ? portSelectInfo[1] : null
    const layout = layoutList.find(item => item.designId === 'Die')
    const dieLayout = layout ? (overviewReverse ? layout.left : layout.right) : []
    const interposer = dieLayout.length ? dieLayout[0].data.interposer : null
    const diePort = interposer && interposer.pairs && interposer.pairs.length ? interposer.pairs.find(item => item.pin === 'diePort') : null
    const diePortNode = diePort ? diePort.node : null
    const pkgPort = interposer && interposer.pairs && interposer.pairs.length ? interposer.pairs.find(item => item.pin === 'pkgPort') : null
    const pkgPortNode = pkgPort ? pkgPort.node : null
    const usedNodes = interposer && interposer.pairs && interposer.pairs.length ? interposer.pairs.map(item => item.node) : []
    const unusedNodes = nodes.filter(item => !usedNodes.includes(item))
    const fileName = interposer && interposer.fileName ? interposer.fileName : null
    const subckt = interposer && interposer.subckt ? interposer.subckt : null
    return (
      (<div className="cascade-imp-overview-column" key={'interposer'}>
        <div className="cascade-imp-overview-layout" key='Interposer' id='Interposer'>
          <Tooltip classNames={{ root: 'aurora-tooltip' }} title={'Interposer'}>
            <div className="layout-title">
              <span>{'Interposer'}</span>
              <CloseOutlined className="layout-delete-icon cascade-icon-button" onClick={(e) => this.deleteInterposer(e)} />
            </div>
          </Tooltip>
          <div className="layout-content" style={{ height: 210 }}>
            <div className="layout-components" style={{ top: 40 }}>
              {interposerType === PER_PORT ? <Fragment>
                <div style={{ top: -30 }}
                  className={`${overviewReverse ? 'layout-port-select-reverse' : 'layout-port-select'}`}>
                  <span className='layout-port-title'>Bump port</span>
                  <TreeSelect
                    value={_portSelect}
                    styles={{ popup: { root: { maxHeight: 300, overflow: 'auto' } } }}
                    treeData={portInfoTreeData}
                    placeholder="Please select"
                    className='aurora-select layout-port-select-box'
                    popupClassName="aurora-select-dropdown layout-port-tree-select"
                    treeDefaultExpandAll
                    onChange={(value) => this.onPortChange(value, 0, die)}
                    popupMatchSelectWidth={false}
                  />
                </div>
                <div
                  style={{ top: 137 }}
                  className={`${overviewReverse ? 'layout-port-count-reverse' : 'layout-port-count'}`}
                >Port {currentPort} / {portCount}</div>
                <div className={`${overviewReverse ? 'layout-die-node-reverse' : 'layout-die-node'}`} >
                  {this.selectRender(diePortNode, unusedNodes, die, 'diePort', powerNet, portIndex)}
                </div>
                <div className={`${overviewReverse ? 'layout-pkg-node-reverse' : 'layout-pkg-node'}`}>
                  {this.selectRender(pkgPortNode, unusedNodes, die, 'pkgPort', powerNet, portIndex)}
                </div>
              </Fragment> : <Fragment>
                <div
                  style={{ top: 40 }}
                  className={`layout-unified-node-reverse`}
                >
                  {`${portCount} ${portCount > 1 ? 'nodes' : 'node'}`}
                </div>
                <div
                  style={{ top: 40 }}
                  className={`layout-unified-node`}
                >
                  {`${portCount} ${portCount > 1 ? 'nodes' : 'node'}`}
                </div>
              </Fragment>}
              <div className='layout-interposer' onClick={() => this.openInterposerPanel(interposer, die, powerNet, portIndex)}>
                {
                  fileName ? <Fragment>
                    <div title={fileName}>{fileName}</div>
                    <div title={subckt}>{subckt}</div>
                  </Fragment> :
                    <div className='cascade-layout-model-empty'>Click to add model</div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>)
    );
  }

  renderInterposer = (index) => {
    const { hasInterposer, impedanceOverviewDisplay } = this.props
    const overviewReverse = impedanceOverviewDisplay === PCB_PACKAGE_DIE
    if (hasInterposer &&
      ((overviewReverse && index === TARGET_PACKAGE_INDEX) ||
        (!overviewReverse && index === TARGET_DIE_INDEX))
    ) {
      return this.interposerRender(index);
    }
  }

  layoutsRender = (layouts, index, hasSocket) => {
    const { impedanceOverviewDisplay } = this.props;
    const reverse = impedanceOverviewDisplay === PCB_PACKAGE_DIE
    return <Fragment key={index}>
      <div className="cascade-imp-overview-column" key={index} style={{ left: `${(index - 1) * 300}px` }}>
        {layouts.map(layout => this.layoutRender(layout))}
        {hasSocket && <div className={reverse ? 'layout-add-model-icon-reverse' : 'layout-add-model-icon'}>
          <Tooltip title={"Add socket"} classNames={{ root: 'aurora-tooltip' }}>
            <PlusCircleOutlined className='add-model-icon' onClick={() => this.openAddModelPanel(index)} />
          </Tooltip>
        </div>}
      </div>
      {this.renderInterposer(index)}
    </Fragment>
  }

  layoutRender = (layout) => {
    const { designId, type, designName: layoutName, customType, index: layoutIndex, socket, powerDomains, asPassiveBoard } = layout;
    const { layoutList, portSelect, portInfo } = this.state;
    const { pcbId, impedanceOverviewDisplay, hasPkg, targetDie: targetDies } = this.props;
    const overviewReverse = impedanceOverviewDisplay === PCB_PACKAGE_DIE
    const dieModelClassName = overviewReverse ? 'layout-die-model-reverse' : 'layout-die-model'
    const dieModelPairsClassName = overviewReverse ? 'layout-model-pairs-reverse' : 'layout-model-pairs'
    const dieModelCPMPairsClassName = overviewReverse ? 'layout-model-cpm-pairs-reverse' : 'layout-model-cpm-pairs'
    const dieIconClassName = overviewReverse ? 'layout-current-icon-reverse' : 'layout-current-icon'
    const currentLayout = layoutList.find(item => item.designId === designId);
    const designName = designConstructor.getDesignName(designId) || layoutName;
    const _designName = designName.replace(/[^\w\d_]/g, '')
    const socketName = socket && socket.files ? socket.files.map(item => item.fileName ? item.fileName : item.subckt ? item.subckt : null) : []
    if (!currentLayout) {
      return null;
    }
    const { left, right, height } = currentLayout;
    const { portsNum, bgaPortsNum, diePortsNum } = this.getPortsNum(layout)
    return (
      <div className="cascade-imp-overview-layout" key={designId} id={`PCB-${_designName}`}>
        <Tooltip classNames={{ root: 'aurora-tooltip' }} title={designName}>
          <div className="layout-title" onClick={(e) => this.changeImpedancePage(e, designId, type)}>
            <span>{designName}</span>
            {IMPEDANCE_LAYOUT_LIST.includes(type) && <ImportOutlined className="layout-in-icon cascade-icon-button" />}
            {type === IMPEDANCE_INTERPOSER_LAYOUT && <RedoOutlined className="layout-switch-icon cascade-icon-button" onClick={(e) => this.refreshInterposer(e, designId)} />}
            {designId !== pcbId && IMPEDANCE_PACKAGE_LIST.includes(type) && <RetweetOutlined className="layout-switch-icon cascade-icon-button" onClick={(e) => this.switchPkg(e, designId)} />}
            {designId !== pcbId && type === IMPEDANCE_PCB && <RetweetOutlined className="layout-switch-icon cascade-icon-button" onClick={(e) => this.changeSwitchPcb(e, designId)} />}
            {designId !== pcbId && <CloseOutlined className="layout-delete-icon cascade-icon-button" onClick={(e) => this.deleteLayout(e, designId, layoutIndex)} />}
          </div >
        </Tooltip >
        <div className="layout-content" style={{ height }}>
          {type !== IMPEDANCE_DIE && <div className="layout-add-connector">
            {
              type === PACKAGE || type === IMPEDANCE_PACKAGE_FILE ? <Tag>Package</Tag>
                : type === IMPEDANCE_SOCKET ? <Tag>Socket</Tag>
                  : type === IMPEDANCE_INTERPOSER_LAYOUT ? <Tag>Interposer</Tag>
                    : asPassiveBoard ? <Tag>Passive PCB</Tag> : <Tag>PCB</Tag>
            }
          </div>}

          <div className="layout-components" style={{ ...(type === IMPEDANCE_DIE ? { top: 40 } : {}) }} >
            {type === IMPEDANCE_SOCKET ? this.layoutSocketRender(layoutIndex, socketName, `PCB-${_designName}-${IMPEDANCE_SOCKET}`)
              : type === IMPEDANCE_PACKAGE_FILE ? this.layoutSocketRender(layoutIndex, socketName, `PCB-${_designName}-${IMPEDANCE_PACKAGE_FILE}`)
                : <Fragment>{
                  [...left, ...right].map(item => {
                    const { color, name, index, side, usage, data } = item;
                    const model = data.model || {}
                    const voltage = data.voltage || '1'
                    const targetDie = data.to && data.to[0] ? data.to[0].components[0] : null
                    const rleak = data.rleak || '100'
                    const rdl = data.rdl || '0.001'
                    const powerNet = data.powerNet || null
                    const portIndex = data.portIndex || null
                    const dieCurrent = data.dieCurrent || null
                    const applyCurrent = data.applyCurrent || false
                    const portCount = portInfo.get(targetDie) && portInfo.get(targetDie).count || 0
                    const portInfoTreeData = portInfo.get(targetDie) && portInfo.get(targetDie).treeData || []
                    const portInfoList = portInfoTreeData.reduce((acc, item) => {
                      return acc.concat(item.children.map(child => child.value));
                    }, []);
                    const currentPort = portInfoList.findIndex(item => item === portSelect.get(targetDie)) + 1
                    const { type: modelType, rdieValue, cdieValue, pairs, cpmPairs, fileName = "" } = model
                    let cpmPairsNode = []
                    if (modelType === 'CPM') {
                      cpmPairsNode = this.getPairsNode(cpmPairs, data.powerNets)
                    }
                    return (
                      <Fragment key={`${name}-${index}`}>
                        {name === 'Die' ? <Fragment>
                          {customType !== 'unified' ? <Fragment>
                            <div className={modelType === 'value' ? dieModelClassName : modelType === 'CPM' ? dieModelCPMPairsClassName : dieModelPairsClassName}
                              style={{
                                top: 100 * index,
                                ...(customType === 'unified' ? overviewReverse ? { left: 106 } : { right: 106 } : {})
                              }}
                              onClick={() => this.changeOnDie(targetDie, model, powerNet, portIndex)}
                            >
                              {modelType === 'value' ? <Fragment>
                                <div className='layout-rdie'>
                                  {`R:${rdieValue}Ω`}
                                </div>
                                <div className='layout-cdie'>
                                  {`C:${cdieValue}F`}
                                </div>
                              </Fragment> : modelType === 'CPM' ? <Fragment>
                                <div className='layout-cpm-name' title={fileName}>{fileName}</div>
                                {/* {cpmPairsNode && cpmPairsNode.length ? <Fragment>
                                {cpmPairsNode.map((item, index) => {
                                  const { list, color, top } = item;
                                  if (!list.length) { return null }
                                  return <div key={index} className="layout-cpm-item" style={{ color, top }} title={list.join(' ')}
                                  // onClick={(e) => this.clickPairs(e, targetDie)}
                                  >
                                    {list.map(name => <div key={name}>{name}</div>)}
                                  </div>
                                })}
                              </Fragment> : null} */}
                              </Fragment> :
                                <Fragment>
                                  <div className='layout-node-1'>{pairs[0].node}</div>
                                  <div className='layout-node-2'>{pairs[1].node}</div>
                                </Fragment>}
                            </div>
                            <div
                              style={{ top: 100 * index }}
                              className={`${dieIconClassName} ${customType === 'CPM' ? 'layout-current-icon-disabled' : ''}`}
                              id={`layout-current-icon-${index}`}
                              onClick={(e) => { customType !== 'CPM' && this.openCurrentPanel(e, dieCurrent, designId, targetDie, powerNet, portIndex) }}>
                              <ArrowDownOutlined style={{ fontSize: '20px', color: '#798DA6' }} />
                            </div>
                            {modelType !== 'CPM' && customType !== 'unified' && <Fragment>
                              <div
                                style={{ top: 94 + index * 100, cursor: 'pointer' }}
                                className={`${overviewReverse ? 'layout-rleak-reverse' : 'layout-rleak'}`}
                                onClick={(e) => this.changeRleakRdl(e, rleak, rdl, targetDie, powerNet, portIndex)}
                              >
                                R-leak:
                                <div className='component-value'>
                                  <span
                                    className={`component-span`}
                                  >{`${rleak ? rleak : '____'}`}
                                  </span>MΩ
                                </div>
                              </div>
                              <div
                                style={{ top: 40 + index * 100, cursor: 'pointer' }}
                                className={`${overviewReverse ? 'layout-rdl-reverse' : 'layout-rdl'}`}
                                onClick={(e) => this.changeRleakRdl(e, rleak, rdl, targetDie, powerNet, portIndex)}
                              >
                                R-rdl:
                                <div className='component-value'>
                                  <span
                                    className={`component-span`}
                                  >{`${rdl ? rdl : '____'}`}
                                  </span>mΩ
                                </div>
                              </div>
                            </Fragment>}
                            {targetDies.length === 1 && <Fragment>
                              {customType !== 'CPM' && <div style={{ top: -30 + index * 100 }}
                                className={`${overviewReverse ? 'layout-port-select-reverse' : 'layout-port-select'}`}>
                                <span className='layout-port-title'>Bump port</span>
                                <TreeSelect
                                  value={portSelect.get(targetDie)}
                                  styles={{ popup: { root: { maxHeight: 300, overflow: 'auto' } } }}
                                  treeData={portInfoTreeData}
                                  placeholder="Please select"
                                  className='aurora-select layout-port-select-box'
                                  popupClassName="aurora-select-dropdown layout-port-tree-select"
                                  popupMatchSelectWidth={false}
                                  treeDefaultExpandAll
                                  onChange={(value) => this.onPortChange(value, index, targetDie)}
                                />
                                {/* <Icon type='table' className='cascade-imp-icon' /> */}
                              </div>}
                              <div
                                style={{ top: 137 + index * 100 }}
                                className={`${overviewReverse ? 'layout-port-count-reverse' : 'layout-port-count'}`}
                              > {customType !== 'CPM' ? (
                                `Port ${currentPort} / ${portCount}`
                              ) : (
                                `${portCount} ${portCount > 1 ? 'ports' : 'port'}`
                              )}</div>
                            </Fragment>}
                          </Fragment> : <Fragment>
                            <div
                              style={{ top: 100 * index }}
                              className={`layout-unified-die${overviewReverse ? '-reverse' : ''}`}
                              id={`layout-unified-die-${index}`}
                              onClick={() => this.changeOnDie(targetDie, model, powerNet, portIndex)}
                            >
                              <div className={`layout-unified-current layout-unified-current-1${overviewReverse ? '-reverse' : ''}`} >
                                <ArrowDownOutlined style={{ fontSize: '16px', color: '#798DA6' }} />
                                <div className='layout-unified-current-name'>1</div>
                              </div>
                              <div className={`layout-unified-current layout-unified-current-2${overviewReverse ? '-reverse' : ''}`} >
                                ...
                              </div>
                              <div className={`layout-unified-current layout-unified-current-3${overviewReverse ? '-reverse' : ''}`}>
                                <ArrowDownOutlined style={{ fontSize: '16px', color: '#798DA6' }} />
                                <div className='layout-unified-current-name'>{portCount}</div>
                              </div>
                            </div>
                            <div
                              style={{ top: 40 + 100 * index }}
                              className={`layout-unified-node${overviewReverse ? '-reverse' : ''}`}
                            >
                              {`${portCount} ${portCount > 1 ? 'nodes' : 'node'}`}
                            </div>
                          </Fragment>
                          } </Fragment> : <Fragment>
                          <Tooltip
                            classNames={{ root: "aurora-tooltip cascade-detail-tooltip" }}
                            title={this.getComponentPowerDomains(layout, name)}
                          >
                            <div
                              style={{ backgroundColor: color, top: 100 * index }}
                              className={`layout-item layout-item-${side} ${usage === CONNECTOR ? 'aurora-cursor' : ''}`}
                              onClick={() => type === IMPEDANCE_DIE ? this.changeOnDie() : usage === CONNECTOR ? this.changeAddConnVisible({ designId, designName, data, type, asPassiveBoard }) : null}
                              key={name}
                              id={`PCB-${_designName}-${name}-${index}`}
                            >
                              <span title={name}>{name}</span>

                              {[PMIC, VRM].includes(usage) && <Fragment>
                                <div className='component-value'>
                                  {this.layoutVoltageRender(powerDomains, name, designId)}
                                </div>
                                <div className='layout-gnd-v-line'></div>
                                <div className='layout-gnd-h-line'></div>
                                <div className='layout-gnd-text'>GND</div>
                              </Fragment>
                              }
                              {usage === IC && !hasPkg && <Fragment>
                                <div className='layout-ic-current-box'>
                                  <Checkbox checked={applyCurrent} onChange={e => this.changeCurrentStatus(e, designId, name)} />
                                  <span className='layout-ic-current-title'>Current</span>
                                  <Tooltip title={applyCurrent ? 'Open current setting' : 'Please enable current option'} classNames={{ root: 'aurora-tooltip' }}>
                                    <div className='layout-ic-current-icon-box' onClick={(e) => applyCurrent ? this.openCurrentPanel(e, dieCurrent, designId, name) : null}>
                                      <span className={`iconfont icon-boxingtu  ${applyCurrent ? 'layout-ic-current-icon' : 'layout-ic-current-icon-disabled'}`} />
                                    </div>
                                  </Tooltip>
                                </div>
                              </Fragment>
                              }
                              {usage === CONNECTOR && <CloseOutlined className="delete-connector-icon layout-delete-icon" onClick={(e) => this.deleteConnector(e, designId, name)} />}
                            </div>
                          </Tooltip>
                        </Fragment>
                        }
                      </Fragment>)
                  })}</Fragment>}
          </div>
          {[IMPEDANCE_PACKAGE, IMPEDANCE_PACKAGE_FILE].includes(type) && <div className={`layout-pkg-port-num`}   >
            <span className={`${overviewReverse ? 'layout-pkg-bga-port-num-reverse' : 'layout-pkg-bga-port-num'}`}> {`${bgaPortsNum} ${bgaPortsNum > 1 ? 'ports' : 'port'}`}</span>
            <span className={`${overviewReverse ? 'layout-pkg-die-port-num-reverse' : 'layout-pkg-die-port-num'}`}> {`${diePortsNum} ${diePortsNum > 1 ? 'ports' : 'port'}`}</span>
          </div>}
          {type === IMPEDANCE_PCB && <div className={`${overviewReverse ? 'layout-pcb-port-num-reverse' : 'layout-pcb-port-num'}`}>  {`${portsNum} ${portsNum > 1 ? 'ports' : 'port'}`}  </div>}
          {
            type === IMPEDANCE_PCB || type === IMPEDANCE_INTERPOSER_LAYOUT ? <div className={`${overviewReverse ? 'layout-add-connector-reverse' : 'layout-add-connector'}`}>
              <Button size='small' className="connector-button" type="primary" onClick={() => this.changeAddConnVisible({ designId, designName, type, asPassiveBoard })}>+ CONN</Button>
            </div> : null
          }
        </div >
      </div >
    );
  }

  layoutVoltageRender = (powerDomains = [], name, designId) => {
    if (!powerDomains.length) {
      return null;
    }
    const _powerDomains = powerDomains.filter(domain => {
      const { content = {} } = domain;
      const { VRM = [] } = content
      if (VRM.some(vrm => vrm.VRM_COMP.includes(name))) {
        return true;
      }
      return false;
    })
    if (_powerDomains.length === 1) {
      const voltage = _powerDomains[0].content.voltage || '1';
      const id = _powerDomains[0].id
      return <Fragment>
        {this.inputRender(voltage, id, 'voltage', designId)}
        <span className="cascade-component-value-title">&nbsp;V</span>
      </Fragment>
    }
    return <Fragment>
      <Popover
        trigger={'click'}
        destroyOnHidden={true}
        content={this.layoutSingleVoltageRender(_powerDomains, designId)}
      >
        <span
          className={`component-span`}
          style={{ cursor: 'pointer' }}
        >Voltage</span>
      </Popover>
    </Fragment>
  }

  layoutSingleVoltageRender = (powerDomains, designId) => {
    return <div className='cascade-layout-multi-voltage-content'>
      {
        powerDomains.map((domain, index) => {
          const { id, content = {} } = domain;
          const { voltage = '1', MAIN_POWER_NETS = [] } = content
          return <div key={index}>
            <span>{MAIN_POWER_NETS[0] || `Power Domain ${index}`} (Voltage) = </span>
            {this.inputRender(voltage, id, 'voltage', designId)}
            <span className="cascade-component-value-title">&nbsp;V</span>
          </div>
        })
      }
    </div>
  }

  layoutSocketRender = (layoutIndex, socketName, id) => {
    return <div className='layout-socket' onClick={() => this.openModelPanel(layoutIndex)} id={id}>
      {
        socketName.length ?
          <div className='layout-socket-name' title={socketName.join(',')}>
            {socketName.join(', ')}
          </div>
          : <div className='cascade-layout-model-empty'>Click to add model</div>
      }
    </div>
  }

  calcTargetICData = (data) => {
    const impPcbData = data.filter(item => item.type === IMPEDANCE_PCB);
    const impHasDie = data.find(item => item.designId === IMPEDANCE_DIE);
    if (!impPcbData.length) {
      return false
    } else {
      for (const impData of impPcbData) {
        const ic = impData.ICs.find(item => item.applyCurrent && item.dieCurrent && item.dieCurrent.currentPoints && item.dieCurrent.currentPoints.length)
        if (ic) {
          return ic
        }
      }
      if (!impHasDie) {
        return false
      } else {
        const ic = impHasDie.ICs.find(item => item.dieCurrent)
        if (ic) {
          return ic
        }
        return true
      }
    }
  }

  createDie = () => {
    const { data } = this.props
    if (data.find(layout => {
      const { extraction = {}, type } = layout || {}
      if (IMPEDANCE_LAYOUT_LIST.includes(type)) {
        if (extraction.enableLinearSweep) {
          const customFrequencySweep = extraction.customFrequencySweep || []
          return customFrequencySweep.length > 0 && customFrequencySweep[customFrequencySweep.length - 1].end === '2e8'
        } else {
          return extraction.FMAX && layout.extraction.FMAX === '2e8'
        }
      }
    })) {
      this.setState({
        message: 'Do you want to change the extraction frequency from 200MHz to 2000MHz?'
      })
    } else {
      this.props.createDie(false);
    }
  }

  updateFrequcy = async (bool) => {
    this.props.createDie(bool);
    this.setState({
      message: false
    })
  }

  render() {
    const { loading, openProjectId, data, customSpiceList, customTouchstoneList, target, maxFreq, packageId, pcb, packageChannelId, channelId, hasInterposer, targetDie, multiPkgDomain, impedanceOverviewDisplay, ICs, interposerType, hasPkg } = this.props;
    const { width, height, addPCB, addConnector, onDie, openTarget, openCurrent, currentPkgId, currentPcbId, openSwitchPkg, openSwitchPcb, cpmCsmVisible, targetPkg, modelType, leftModelTitle, rightModelTitle,
      pdnInfo, dieCurrent, openInterposer, interposer, currentDesignId, maxStopTime, openRleakRdl, rleak, rdl, openTransientTime, addModel, modelVisible, portList, targetSocket, interposerPowerNet, interposerIndex, interposerDie, message } = this.state;
    const designIds = data.map(d => d.designId);
    const designTypes = data.map(d => ({ designId: d.designId, type: d.type }))
    const hasDie = data.find(item => item.designId === IMPEDANCE_DIE);
    const targetText = target && target.length ? target.length > 1 ? `${target[0].targetName}, +${target.length - 1}` : target[0].targetName : ''
    const pkg = data.find(item => item.index === TARGET_PACKAGE_INDEX)
    const packageIsPrelayout = pkg ? designConstructor.isPreLayout(pkg.designId) : false;
    const targetICData = this.calcTargetICData(data)
    const overviewReverse = impedanceOverviewDisplay === PCB_PACKAGE_DIE
    return <Fragment>
      <Spin spinning={loading ? true : false} tip={loading}>
        <div className="cascade-imp-overview">
          <div>
            <span className="font-bold cascade-setup-title-color">Overview</span>
            <div className="cascade-imp-overview-button-group">
              <Tooltip title={"Add new layout"} classNames={{ root: 'aurora-tooltip' }}>
                <PlusCircleOutlined className='cascade-imp-icon' onClick={() => this.changeAddPCBVisible(true)} />
              </Tooltip>
              <Tooltip title={"Trace PMIC"} classNames={{ root: 'aurora-tooltip' }}>
                <PlayCircleOutlined className='cascade-imp-icon' onClick={this.props.traceOverview} />
              </Tooltip>
            </div>
            {
              data.length > 1 ? <div className="cascade-imp-multi-pcb-target" onClick={(e) => this.changeTargetPanel(e, true)}>
                <span>Target {targetText ? `: ${targetText}` : ''}</span>
              </div> : null
            }
            {
              targetICData && <div className="cascade-imp-multi-pcb-target" onClick={(e) => this.changeTransientPanel(e, true)}>
                <span>Transient Time</span>
              </div>
            }
          </div>
          <div className="space-10 cascade-imp-overview-content" id="cascade-imp-overview-content">
            <div className="cascade-imp-overview-layouts-box">{this.contentRender()}</div>
            <canvas id={`impedance-overview`} className="impedance-overview-canvas" width={width} height={height} />
          </div>
        </div>
      </Spin>
      {
        addPCB && <PCBPanel
          closeModal={this.changeAddPCBVisible}
          projectId={openProjectId}
          createNewLayout={this.props.createNewLayout}
          designIds={designIds}
          deleteShip={this.props.deleteShip}
          hasDie={hasDie}
          createDie={this.createDie}
          hasInterposer={hasInterposer}
          saveHasInterposer={this.props.saveHasInterposer}
          getAutoConnectionNet={this.getAutoConnectionNet}
          createPackageFile={this.props.createPackageFile}
          designTypes={designTypes}
          targetDie={targetDie}
        />
      }
      {
        addConnector && <ConnectorPanel
          designIds={designIds}
          projectId={openProjectId}
          designTypes={designTypes}
          {...addConnector}
          closeModal={() => this.changeAddConnVisible(false)}
          createNewLayout={this.props.createNewLayout}
          deleteShip={this.props.deleteShip}
          getAutoConnectionNet={this.getAutoConnectionNet}
        />
      }
      {
        onDie && <CascadeOnDieModelPanel
          product={CASCADE}
          name={'onDie'}
          pdnInfo={onDie.pdnInfo}
          powerNet={onDie.powerNet}
          targetDie={onDie.targetDie}
          portIndex={onDie.portIndex}
          pkgDomains={onDie.pkgDomains}
          closePanel={this.closeOnDiePanel}
          onDieTouchstoneList={customTouchstoneList}
          onDieSpiceList={customSpiceList}
          getPkgSpiceModelList={getPkgSpiceModelList}
          packageIsPrelayout={packageIsPrelayout}
          getCPMCSMContent={this.getCPMCSMContent}
          maxStopTime={maxStopTime}
          multiTargetDie={targetDie.length > 1}
          multiPkgDomain={multiPkgDomain}
        />
      }
      {cpmCsmVisible && cpmCsmVisible.key && <CpmCsmSelectPanel
        cpmCsmVisible={cpmCsmVisible}
        changeCpmCsmVisible={this.changeCpmCsmVisible}
        pdnInfo={pdnInfo}
        packageId={packageId}
        packageChannelId={packageChannelId}
        closeFilePanel={this.closeOnDiePanel}
        pcb={pcb}
        channelId={channelId}
        product={CASCADE}
        targetPkg={targetPkg}
        modelType={'CPM'}
        getCSMCPMSpiceModelList={getCascadeCSMCPMSpiceModelList}
      />}
      {
        openTarget && <TargetPanel
          powerDomainId={'overview'}
          target={target}
          maxFreq={maxFreq}
          multiPCB={true}
          title={'Target'}
          updateTarget={this.props.saveMultiPCBTarget}
          closeTargetPanel={this.changeTargetPanel}
        />
      }
      {
        openCurrent && <DieCurrentPanel
          title={`${currentDesignId === 'Die' ? 'Die' : 'IC'} Current`}
          dieCurrent={dieCurrent}
          updateDieCurrent={this.updateCurrent}
          closeCurrentPanel={this.changeCurrentPanel}
          customSpiceList={customSpiceList}
          applyVisible={currentDesignId === 'Die' ? true : false}
          maxStopTime={maxStopTime}
        />
      }
      {
        openSwitchPkg && <SwitchPcbPanel
          type={IMPEDANCE_PACKAGE}
          projectId={openProjectId}
          designId={currentPkgId}
          switchPcb={this.props.switchPackage}
          closeSwitchPanel={this.changePkgPanel}
          designIds={designIds}
        />
      }
      {
        openSwitchPcb && <SwitchPcbPanel
          type={IMPEDANCE_PCB}
          projectId={openProjectId}
          designId={currentPcbId}
          switchPcb={this.switchPcb}
          closeSwitchPanel={this.changePcbPanel}
          designIds={designIds}
        />
      }
      {
        openInterposer && <InterPoserPanel
          closeModal={this.closeInterposerPanel}
          onDieSpiceList={customSpiceList}
          onDieTouchstoneList={customTouchstoneList}
          interposer={interposer}
          getPkgSpiceModelList={getPkgSpiceModelList}
          ICs={ICs}
          interposerPowerNet={interposerPowerNet}
          interposerIndex={interposerIndex}
          interposerType={interposerType}
          interposerDie={interposerDie}
          pkg={hasPkg}
          overviewReverse={overviewReverse}
        />
      }
      {
        openRleakRdl && <RleakRdlPanel
          closeModal={this.closeRleakRdlPanel}
          rleak={rleak}
          rdl={rdl}
        />
      }
      {
        openTransientTime && <TransientTimePanel
          closeModal={this.closeTransientTimePanel}
          targetICData={targetICData}
        />
      }
      {
        addModel && <AddModelPanel
          closeModal={this.changeAddModelVisible}
          createModel={this.createModel}
        />
      }
      {
        modelVisible && <ModelPanel
          type={modelType}
          spiceList={customSpiceList}
          touchstoneList={customTouchstoneList}
          getPkgSpiceModelList={getPkgSpiceModelList}
          closeModal={this.closeModelPanel}
          portList={portList}
          model={targetSocket}
          overviewReverse={overviewReverse}
          leftModelTitle={leftModelTitle}
          rightModelTitle={rightModelTitle}
        />
      }
      {message ? <DelConfirm
        type='update'
        onUpdate={() => this.updateFrequcy(true)}
        cancelUpdate={() => this.updateFrequcy(false)}
        message={message}
      /> : null}
    </Fragment>
  }
}

const mapState = (state) => {
  const { CascadeReducer: {
    project: { openProjectId },
    Impedance: { designId, verificationId, loading, targetIC, targetDie = [], data = [], status, page, target = [], impedanceOverviewDisplay, hasInterposer, packageRelationship = [] },
    library: { customSpiceList, customTouchstoneList, cpmList } } } = state
  const layout = data.find(item => item.designId === designId);
  const hasPkg = data.find(item => item.index === TARGET_PACKAGE_INDEX)
  const hasDie = data.find(item => item.index === TARGET_DIE_INDEX)
  const customModelType = hasDie ? hasDie.customType : ''
  const interposerType = hasDie ? hasDie.interposerType : ''
  const packageId = hasPkg ? hasPkg.designId : ''
  const pcb = designConstructor.getDesign(designId)
  const multiPkgDomain = hasPkg ? hasPkg.powerDomains.length > 1 : false
  const isPostPkgLayout = hasPkg ? hasPkg.type === IMPEDANCE_PACKAGE : false
  const ICs = hasDie ? hasDie.ICs : []
  return {
    loading,
    openProjectId,
    verificationId,
    targetIC,
    data,
    status,
    pcbId: designId,
    page,
    customSpiceList,
    customTouchstoneList,
    target,
    targetDie,
    maxFreq: layout && layout.extraction ? (layout.extraction.FMAX || null) : null,
    impedanceOverviewDisplay,
    packageId,
    pcb,
    hasInterposer,
    hasPkg,
    customModelType,
    cpmList,
    multiPkgDomain,
    isPostPkgLayout,
    ICs,
    interposerType: interposerType || PER_PORT,
    packageRelationship
  };
}

const mapDispatch = (dispatch) => ({
  changeImpedancePage(page) {
    dispatch(changeImpedancePage(page))
  },
  createNewLayout(pcbId, connectors, asInterposer, asPassiveBoard) {
    dispatch(createNewLayout(pcbId, connectors, asInterposer, asPassiveBoard))
  },
  updateImpedanceStatus(status) {
    dispatch(updateImpedanceStatus(status))
  },
  deleteLayout(designId, index) {
    dispatch(deleteLayout(designId, index))
  },
  deleteConnector(designId, connector) {
    dispatch(deleteLayoutConnector(designId, connector))
  },
  traceOverview() {
    dispatch(traceOverview())
  },
  deleteShip(ship, connector) {
    dispatch(deleteShip(ship, connector))
  },
  createDie(update) {
    dispatch(createDie(update))
  },
  saveOnDieModel(model, targetDie, modelPowerNet, modelIndex, apply, customType, dieCurrentList) {
    dispatch(saveOnDieModel(model, targetDie, modelPowerNet, modelIndex, apply, customType, dieCurrentList))
  },
  saveMultiPCBTarget(target) {
    dispatch(saveMultiPCBTarget(target))
  },
  saveDieCurrent({ dieCurrent, currentDesignId, currentComp, currentPowerNet, currentIndex, apply }) {
    dispatch(saveDieCurrent({ dieCurrent, currentDesignId, currentComp, currentPowerNet, currentIndex, apply }))
  },
  savePMICVoltage(value, name, usage) {
    dispatch(savePMICVoltage(value, name, usage))
  },
  switchPackage(designId) {
    dispatch(switchPackage(designId))
  },
  switchPcb(pcbId, prevPcbId) {
    dispatch(switchPcb(pcbId, prevPcbId))
  },
  saveInterposer(info, interposerDie, interposerPowerNet, interposerIndex, apply) {
    dispatch(saveInterposer(info, interposerDie, interposerPowerNet, interposerIndex, apply))
  },
  saveInterposerNode(value, key, name, powerNet, portIndex) {
    dispatch(saveInterposerNode(value, key, name, powerNet, portIndex))
  },
  saveHasInterposer(hasInterposer) {
    dispatch(saveHasInterposer(hasInterposer))
  },
  updateCurrentStatus(enable, designId, name) {
    dispatch(updateCurrentStatus(enable, designId, name))
  },
  saveRleakAndRrdl({ rleak, rdl, apply, rComp, rPowerNet, rPortIndex }) {
    dispatch(saveRleakAndRrdl({ rleak, rdl, apply, rComp, rPowerNet, rPortIndex }))
  },
  saveTransientTimeSetting(startTime, stopTime, stepTime) {
    dispatch(saveTransientTimeSetting(startTime, stopTime, stepTime))
  },
  createModel(layoutType, addModelIndex) {
    dispatch(createModel(layoutType, addModelIndex))
  },
  saveSocket({ files, pairs, targetSocketIndex }) {
    dispatch(saveSocket({ files, pairs, targetSocketIndex }))
  },
  createPackageFile(fileId) {
    dispatch(createPackageFile(fileId))
  },
  updatePackageFile({ files, pairs }) {
    dispatch(updatePackageFile({ files, pairs }))
  },
  saveVRM(params, key) {
    dispatch(saveVRM(params, key))
  },
  refreshInterposer(designIds) {
    dispatch(refreshInterposer(designIds))
  }
})

export default connect(mapState, mapDispatch)(OverviewPage);
